
export const mobileErrText: string = '请输入正确的手机号';

export const passwordErrText: string = '请输入6-20数字或字母';

export const vcodeErrText: string = '验证码为4位数字';